export default "__VITE_PUBLIC_ASSET__4389189b__"